import { ActionTypeWithProps } from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                              from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                              from '@ngrx/store';
import {
	ListOperations,
	ListOperationsIdentifierEnum
}                              from '@shared/list-operations/model/list-operations.model';


export interface IListOperationsActions extends IAdapterActions<ListOperations> {
	setActiveListOperationsId: ActionTypeWithProps<IPropsUpdateActiveListOperationsIdState>;
}


export interface IPropsUpdateActiveListOperationsIdState extends IBaseProps {
	activeListOperationsId: ListOperationsIdentifierEnum;
}

export function listOperationsActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<ListOperations>( storeId ),

		// LIST OPERATION SPECIFIC ACTIONS ###########################################################################################################
		setActiveListOperationsId: createAction( `[${ storeId }] State activeListOperationsId`, props<IPropsUpdateActiveListOperationsIdState>() )
	};
}

